import samplemodule from './samplemodule/app.js';

window.samplemodule = samplemodule;